import {TOOLTIP_POSITION} from '@Components/tooltip';
import {getClassesForPosition} from '@Components/tooltip/tooltip-helper';
import {TooltipPlacement} from './icon-with-tooltip.types';

export function getTooltipOverlayClassName(hideArrow: boolean, arrowPosition: TOOLTIP_POSITION): string {
  return ['spacing-m-b-1', hideArrow ? null : '_rounded-arrow', getClassesForPosition(arrowPosition)].filter(Boolean).join(' ');
}

export function deriveArrowPositionFromPlacement(placement: TooltipPlacement): TOOLTIP_POSITION {
  switch (placement) {
    case TooltipPlacement.BOTTOM:
      return TOOLTIP_POSITION.TOP_MIDDLE;
    case TooltipPlacement.LEFT:
      return TOOLTIP_POSITION.BOTTOM_RIGHT;
    case TooltipPlacement.RIGHT:
      return TOOLTIP_POSITION.BOTTOM_LEFT;
    case TooltipPlacement.TOP:
    default:
      return TOOLTIP_POSITION.BOTTOM_MIDDLE;
  }
}
